import React from 'react';
type PageType = 'home' | 'commercial' | 'services' | 'residential' | 'reservation' | 'cinema';
interface HeroServicesProps {
  onNavigate: (page: PageType) => void;
}
const cards = [{
  label: 'SLUŽBY',
  svg: 'https://cdn.magicpatterns.com/uploads/99M8AaifK4Np5aajqGFYJE/sluzby.svg',
  page: 'services' as PageType
}, {
  label: 'KOMERČNÍ ŘEŠENÍ',
  svg: 'https://cdn.magicpatterns.com/uploads/xfiPLUBWnjtdALuLdefFW3/komerce.svg',
  page: 'commercial' as PageType
}, {
  label: 'REZIDENČNÍ ŘEŠENÍ',
  svg: 'https://cdn.magicpatterns.com/uploads/5S9rCkney38jHHBLoQTQXv/rezidence.svg',
  page: 'residential' as PageType
}];
export function HeroServices({
  onNavigate
}: HeroServicesProps) {
  return <section id="hero" className="w-full bg-white py-6 md:py-12" data-id="element-191">
      <div className="max-w-6xl mx-auto px-6" data-id="element-192">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-2 md:gap-6" data-id="element-193">
          {cards.map(card => <button key={card.page} onClick={() => onNavigate(card.page)} className="flex flex-col items-center cursor-pointer group" data-id="element-194">
              <div className="w-full flex items-center justify-center px-4 py-6 md:py-10" data-id="element-195">
                <img src={card.svg} alt={card.label} className="h-32 md:h-42 w-auto object-contain opacity-[0.44] group-hover:opacity-100 transition-opacity duration-300" data-id="element-196" />
              </div>
              <h3 className="text-[#707070] text-xl md:text-2xl font-normal tracking-wide text-center pb-4" data-id="element-197">
                {card.label}
              </h3>
            </button>)}
        </div>
      </div>
    </section>;
}